module.exports = __webpack_public_path__ + "img/6fd08a5.jpg";